import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RailwayAlertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"railway_alert"}/>
}
